import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	Output
} from '@angular/core';
import { Subject } from 'rxjs';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { SNModalService } from '@web-services/modal/snModal.service';
import { DeleteAttachmentModal } from '@web-components/jobs/common/delete-atachment-modal/delete-attachment-modal';
import { FileDownloadDataServiceProvider } from '@services/files/file-download-service/file-download.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { FileUploadDataProvider } from '@services/files/file-upload.data.service';
import { ImageConverterProvider } from '@services/files/image-converter.service';
import { takeUntil } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';

@Component({
	selector: 'job-file-section',
	template: require('./job-file-section.component.html'),
	styles: [require('./job-file-section.component.scss')]
})
export class JobFileSectionComponent implements OnDestroy {
	@Input() files: File[];
	@Input() archived: boolean;
	@Input() jobId: number;
	@Output() updateFilesState: EventEmitter<void> = new EventEmitter();
	isActiveSpinner = false;
	selectedPackageModalRef: NgbModalRef;
	private unsubscribe = new Subject();

	constructor(
		private modalService: SNModalService,
		private fileDownloadDataService: FileDownloadDataServiceProvider,
		private messageService: MessageService,
		private fileUploadService: FileUploadDataProvider,
		private imageConverter: ImageConverterProvider
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	saveFilesOnService({ item, jobId }): void {
		this.isActiveSpinner = true;
		const maxMb = 50; // 50 Mb
		const maxSize = maxMb * 1000 * 1024;

		const totalFilesSize = this.getTotalSize(this.files);
		if (totalFilesSize + item.size > maxSize) {
			this.messageService.showToaster('e_1', 'attachments');
			this.isActiveSpinner = false;
			return;
		}
		this.fileUploadService
			.saveFileOnServer(item, jobId)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(response): void => {
					response.convertedType = this.imageConverter.getFileClass(
						response.name
					);
					this.files.push(response);
					this.messageService.showToaster('s_1', 'attachments');
					this.updateFilesState.emit();
					this.isActiveSpinner = false;
				},
				({ error }): void => {
					const { errorMessage, errorTitle } = error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
					this.isActiveSpinner = false;
				}
			);
	}

	getTotalSize(files): number {
		return files.reduce(
			(prev: number, next): number => prev + next.bytesSize,
			0
		);
	}

	saveAttachment(id: number, jobId: number): void {
		this.fileDownloadDataService.saveFileFromJob(id, jobId).subscribe(
			(response: HttpResponse<Blob>): void =>
				this.fileDownloadDataService.saveToFileSystem(response),
			({ error }): void => {
				const { errorMessage, errorTitle } = error;
				this.messageService.showErrorFromBackend(errorTitle, errorMessage);
			}
		);
	}

	deleteFile(file: File): void {
		this.selectedPackageModalRef = this.modalService.openModal(
			DeleteAttachmentModal,
			{ windowClass: 'ng-bootstrap-modal' }
		);
		this.selectedPackageModalRef.componentInstance.file = file;
		this.selectedPackageModalRef.componentInstance.jobId = this.jobId;
		this.selectedPackageModalRef.componentInstance.files = this.files;
		this.selectedPackageModalRef.result
			.then((): void => {
				this.updateFilesState.emit();
			})
			.catch(() => {});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/jobs/sections/job-file-section/job-file-section.component.ts